import { wwtMemo } from '@wwt/custom/wwt'

import { wwtPerformanceLog } from '@wwt/core/admin'
import { ReservationDto } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

import { cn } from '@/shared/lib/cn'

import { ReservationTabSideTopElement } from '../types/ReservationTabSideTopElement.ts'
import { DownloadVoucher } from './DownloadVoucher/DownloadVoucher.tsx'
import { ReservationTabContactProperty } from './ReservationTabContactProperty.tsx'
import { ReservationTabIsEverythingCorrect } from './ReservationTabIsEverythingCorrect.tsx'
import { ReservationTabReviewOnBooking } from './ReservationTabReviewOnBooking.tsx'

interface ReservationTabSidePanelInfoWrapperProps {
	offer: Offer
	reservation: ReservationDto
	topElement?: ReservationTabSideTopElement
}

/**
 * Everything correct, review on booking and contact wrapper
 *
 * @author Ivan Shchedrovskyi
 */
export const ReservationTabSidePanelReservationInfoWrapper = wwtMemo(
	({
		topElement,
		reservation,
		offer
	}: ReservationTabSidePanelInfoWrapperProps) => {
		wwtPerformanceLog('ReservationTabSidePanelInfoWrapper')

		return (
			<div className="flex flex-col gap-x-10 gap-y-6 rounded-md border-solid border-gray-200 px-5 sm:flex-row sm:gap-y-0 sm:border sm:p-6 sm:shadow-md lg:flex-col lg:p-0">
				{topElement &&
				topElement === ReservationTabSideTopElement.EVERYTHING_CORRECT ? (
					<ReservationTabIsEverythingCorrect className="flex-1 sm:p-0 lg:p-4 xl:p-6" />
				) : (
					topElement === ReservationTabSideTopElement.REVIEW_ON_BOOKING && (
						<ReservationTabReviewOnBooking className="flex-1 sm:p-0 lg:p-4 xl:p-6" />
					)
				)}

				<ReservationTabContactProperty
					className={cn(
						'flex-1 rounded-md sm:p-0 lg:p-4 xl:p-6',
						topElement && 'lg:border-t lg:border-solid lg:border-gray-200'
					)}
					phones={offer.hotelStatic.phones}
					email={offer.hotelStatic.email}
				>
					<DownloadVoucher
						reservationId={reservation.reservationId}
						offer={offer}
					/>
				</ReservationTabContactProperty>
			</div>
		)
	}
)
